export default __webpack_public_path__ + "static/media/logo.d7ec0784991ec80c5b75e72014878c8d.png";